"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_ERROR_MESSAGE = void 0;
/** The default error message to show users */
exports.STANDARD_ERROR_MESSAGE = 'An error has occurred. Our engineers have been notified and are looking into the issue';
